const initialState = {
  products: [],
  categories: [],
  selectedProduct: null,
  loading: false,
  actionLoading: false,
  error: null,
  // Manufacturer Module — Phase 1, Step 6. Only ever populated when the
  // logged-in company is a manufacturer (ProductGroupAction.js is only
  // dispatched from that context) — untouched otherwise.
  productGroups: [],
  productGroupsLoading: false
};

const ProductReducer = (state = initialState, action) => {
  switch (action.type) {
    // Fetch Products
    case 'FETCH_PRODUCTS_REQUEST':
      return { ...state, loading: true, error: null };
    case 'FETCH_PRODUCTS_SUCCESS':
      return { ...state, loading: false, products: action.payload, error: null };
    case 'FETCH_PRODUCTS_FAILURE':
      return { ...state, loading: false, error: action.payload };

    // Get Product by ID
    case 'GET_PRODUCT_REQUEST':
      return { ...state, actionLoading: true, error: null };
    case 'GET_PRODUCT_SUCCESS':
      return { ...state, actionLoading: false, selectedProduct: action.payload, error: null };
    case 'GET_PRODUCT_FAILURE':
      return { ...state, actionLoading: false, error: action.payload };

    // Create Product
    case 'CREATE_PRODUCT_REQUEST':
      return { ...state, actionLoading: true, error: null };
    case 'CREATE_PRODUCT_SUCCESS':
      const newProduct = Array.isArray(action.payload) ? action.payload[0] : action.payload;
      return {
        ...state,
        actionLoading: false,
        products: Array.isArray(state.products) ? [newProduct, ...state.products] : [newProduct],
        error: null
      };
    case 'CREATE_PRODUCT_FAILURE':
      return { ...state, actionLoading: false, error: action.payload };

    // Update Product
    case 'UPDATE_PRODUCT_REQUEST':
      return { ...state, actionLoading: true, error: null };
    case 'UPDATE_PRODUCT_SUCCESS':
      const updatedProduct = Array.isArray(action.payload) ? action.payload[0] : action.payload;
      return {
        ...state,
        actionLoading: false,
        products: Array.isArray(state.products)
          ? state.products.map((p) => (p.id === updatedProduct.id ? updatedProduct : p))
          : [updatedProduct],
        selectedProduct: updatedProduct,
        error: null
      };
    case 'UPDATE_PRODUCT_FAILURE':
      return { ...state, actionLoading: false, error: action.payload };

    // Delete Product
    case 'DELETE_PRODUCT_REQUEST':
      return { ...state, actionLoading: true, error: null };
    case 'DELETE_PRODUCT_SUCCESS':
      return {
        ...state,
        actionLoading: false,
        products: Array.isArray(state.products) ? state.products.filter((p) => p.id !== action.payload) : [],
        error: null
      };
    case 'DELETE_PRODUCT_FAILURE':
      return { ...state, actionLoading: false, error: action.payload };

    // Fetch Categories
    case 'FETCH_CATEGORIES_REQUEST':
      return { ...state, loading: true, error: null };
    case 'FETCH_CATEGORIES_SUCCESS':
      return {
        ...state,
        loading: false,
        categories: Array.isArray(action.payload) ? action.payload : [],
        error: null
      };
    case 'FETCH_CATEGORIES_FAILURE':
      return { ...state, loading: false, error: action.payload };

    // Quick-add Category (mirrors CREATE_PRODUCT_GROUP_SUCCESS below —
    // appends the new category into the same list the form's Category
    // dropdown reads from, no refetch needed)
    case 'CREATE_PRODUCT_CATEGORY_REQUEST':
      return { ...state, loading: true };
    case 'CREATE_PRODUCT_CATEGORY_SUCCESS':
      return {
        ...state,
        loading: false,
        categories: action.payload ? [...(state.categories || []), action.payload] : state.categories
      };
    case 'CREATE_PRODUCT_CATEGORY_FAILURE':
      return { ...state, loading: false, error: action.payload };

    // Clear selected product
    case 'CLEAR_SELECTED_PRODUCT':
      return { ...state, selectedProduct: null };

    // Product Groups (Manufacturer Module — Phase 1, Step 6)
    case 'FETCH_PRODUCT_GROUPS_REQUEST':
      return { ...state, productGroupsLoading: true };
    case 'FETCH_PRODUCT_GROUPS_SUCCESS':
      return { ...state, productGroupsLoading: false, productGroups: Array.isArray(action.payload) ? action.payload : [] };
    case 'FETCH_PRODUCT_GROUPS_FAILURE':
      return { ...state, productGroupsLoading: false };

    case 'CREATE_PRODUCT_GROUP_REQUEST':
      return { ...state, productGroupsLoading: true };
    case 'CREATE_PRODUCT_GROUP_SUCCESS':
      return {
        ...state,
        productGroupsLoading: false,
        productGroups: action.payload ? [...state.productGroups, action.payload] : state.productGroups
      };
    case 'CREATE_PRODUCT_GROUP_FAILURE':
      return { ...state, productGroupsLoading: false };

    default:
      return state;
  }
};

export default ProductReducer;